module.exports = __webpack_public_path__ + "img/txt_icon.96da6cdd.png";